'use client'

import { IconWifiOff } from '@tabler/icons-react'

import { theme } from 'shared/ui/utils/designTokens'

import styles from './OfflineNotificationLayer.module.scss'

const OfflineNotificationLayer = () => (
  <div className={styles.wrapper}>
    <IconWifiOff width={70} height={70} color={theme.colors.text.subtle} />
    <h2>Brak połączenia z siecią</h2>
    <p>Aby kontunować połącz się z siecią internetową</p>
  </div>
)

export default OfflineNotificationLayer
